import type { BlobProvisionResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { blobStoreName } from '../blob/blob-store-name.js'
import { provisionBlobStoreInteractive } from '../blob/provision-blob-store-interactive.js'
import { provisionBlobStore } from '../blob/provision-blob-store.js'

export function provisionBlobForMode(
  runner: VercelRunner,
  options: { cwd: string; projectName: string; interactive: boolean; env?: NodeJS.ProcessEnv }
): Promise<BlobProvisionResult> {
  const opts = { name: blobStoreName(options.projectName), env: options.env }
  return options.interactive
    ? provisionBlobStoreInteractive(runner, options.cwd, opts)
    : provisionBlobStore(runner, options.cwd, opts)
}
